module.exports = __webpack_public_path__ + "static/media/count-themes.68f21964.svg";